module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-203.b49b6582.svg";